import { getBusinessDateString } from '@/utils/dateHelpers';

/** Encompass date-only/midnight-UTC values are calendar dates, not instants.
 * Actual milestone timestamps resolve on the Pacific calendar, not the browser's timezone.
 */
export function brokerFundingDate(value: string | null | undefined): string {
  if (!value) {
    return '';
  }
  const calendar = /^(\d{4}-\d{2}-\d{2})(?:T00:00:00(?:\.0+)?(?:Z|\+00(?::00)?))?$/.exec(value);
  if (calendar) {
    const date = new Date(`${calendar[1]}T12:00:00Z`);
    return Number.isFinite(date.getTime()) && date.toISOString().slice(0, 10) === calendar[1]
      ? calendar[1]
      : '';
  }
  // Only explicit-offset timestamps have an unambiguous business date.
  if (!/T.*(?:Z|[+-]\d{2}:?\d{2})$/.test(value)) {
    return '';
  }
  const date = new Date(value);
  return Number.isFinite(date.getTime()) ? getBusinessDateString(date) : '';
}
